/**
 * Página Ajustes globales — sesión JWT (mismo token que el panel admin).
 * Solo usuarios admin ven el bloque de ajustes; VIP ve aviso y enlaces.
 */
(function () {
  'use strict';

  const TOKEN_KEY = 'raptv_token';

  function getToken() {
    return localStorage.getItem(TOKEN_KEY);
  }

  function showGate() {
    const g = document.getElementById('login-gate');
    if (g) g.style.display = 'flex';
    const shell = document.getElementById('app-shell');
    if (shell) shell.classList.remove('visible');
  }

  function hideGate() {
    const g = document.getElementById('login-gate');
    if (g) g.style.display = 'none';
  }

  function showAppShell() {
    const shell = document.getElementById('app-shell');
    if (shell) shell.classList.add('visible');
  }

  function setHeaderUser(user) {
    const el = document.getElementById('header-username');
    if (el && user && user.username) el.textContent = user.username.toUpperCase();
    const badge = document.querySelector('.admin-badge');
    if (badge && user) {
      if (user.is_admin) {
        badge.textContent = 'ADMIN';
        badge.classList.remove('vip');
      } else {
        badge.textContent = 'VIP';
        badge.classList.add('vip');
      }
    }
  }

  async function fetchMe() {
    const token = getToken();
    if (!token) return null;
    const res = await fetch('/auth/me', {
      headers: { Authorization: 'Bearer ' + token }
    });
    if (!res.ok) {
      localStorage.removeItem(TOKEN_KEY);
      return null;
    }
    return res.json();
  }

  function showAdminSettings() {
    document.getElementById('settings-vip-notice').classList.remove('visible');
    document.getElementById('settings-admin-root').style.display = 'block';
  }

  var _mascotUiBound = false;

  async function initMascotSettingUi() {
    var cb = document.getElementById('setting-mascot');
    var st = document.getElementById('setting-mascot-status');
    if (!cb) return;
    try {
      var res = await fetch('/api/site-config?t=' + Date.now());
      if (res.ok) {
        var cfg = await res.json();
        cb.checked = !!cfg.mascot_enabled;
      }
    } catch (e) {}
    if (_mascotUiBound) return;
    _mascotUiBound = true;
    cb.addEventListener('change', async function () {
      if (st) {
        st.textContent = 'Guardando…';
        st.classList.remove('err');
      }
      cb.disabled = true;
      try {
        var resPut = await fetch('/api/site-config', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getToken()
          },
          body: JSON.stringify({ mascot_enabled: cb.checked })
        });
        if (!resPut.ok) throw new Error('HTTP ' + resPut.status);
        if (st) {
          st.textContent = 'Guardado';
          st.classList.remove('err');
        }
        setTimeout(function () {
          if (st) st.textContent = '';
        }, 2000);
      } catch (e) {
        if (st) {
          st.textContent = 'No se pudo guardar.';
          st.classList.add('err');
        }
        try {
          var r2 = await fetch('/api/site-config?t=' + Date.now());
          if (r2.ok) {
            var c2 = await r2.json();
            cb.checked = !!c2.mascot_enabled;
          }
        } catch (e2) {}
      } finally {
        cb.disabled = false;
      }
    });
  }

  function showVipNotice() {
    document.getElementById('settings-admin-root').style.display = 'none';
    document.getElementById('settings-vip-notice').classList.add('visible');
  }

  async function afterAuth(user) {
    hideGate();
    showAppShell();
    setHeaderUser(user);
    if (user.is_admin) {
      showAdminSettings();
      await initMascotSettingUi();
    } else {
      showVipNotice();
    }
  }

  window.checkLoginSettings = async function () {
    const email = document.getElementById('login-email').value.trim();
    const pass = document.getElementById('login-pass').value;
    const err = document.getElementById('login-error');
    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password: pass })
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem(TOKEN_KEY, data.token);
        if (err) err.style.opacity = '0';
        await afterAuth(data.user);
      } else {
        if (err) err.style.opacity = '1';
        const passEl = document.getElementById('login-pass');
        if (passEl) passEl.value = '';
        setTimeout(function () {
          if (err) err.style.opacity = '0';
        }, 2000);
      }
    } catch (e) {
      if (err) {
        err.textContent = 'ERROR DE CONEXIÓN';
        err.style.opacity = '1';
        setTimeout(function () {
          err.style.opacity = '0';
          err.textContent = 'ACCESO DENEGADO';
        }, 2500);
      }
    }
  };

  window.logoutSettings = function () {
    localStorage.removeItem(TOKEN_KEY);
    window.location.href = 'admin-settings.html';
  };

  document.addEventListener('DOMContentLoaded', async function () {
    const user = await fetchMe();
    if (user) await afterAuth(user);
    else showGate();
  });
})();
